export const isKuhniVersoMebelDomain = (hostname = window.location.hostname) =>
    hostname === "kuhni-verso-mebel.upme.by" || hostname === "kuhni-verso-mebel.t.upme.by";

export const KUHNI_HIDDEN_CUSTOMER_SETTINGS = ["relatedUsers", "favorite-organization"];

export const KUHNI_HIDDEN_CUSTOMER_PROFILE_FIELDS = [
    "email",
    "registrationNumber",
    "organizationalAndLegalForm",
];

export const KUHNI_HIDDEN_CUSTOMER_PERSONALIZATION_FIELDS = ["position"];

export const kuhniVersoTabletContainerQuerySx = {
    "@media (max-width: 1023px)": {
        maxWidth: "900px",
        paddingLeft: "16px",
        paddingRight: "16px",
    },
};
